import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../types';

const getOperator = function (state: RootState) {
  return state?.operator;
};

const getLoactions = function (state: RootState) {
  return state?.location;
};

const getProducts = function (state: RootState) {
  return state?.product;
};

export const getOperatorDetail = createSelector(getOperator, (operator) => {
  const list = operator?.operators?.data?.map((operator) => ({
    id: operator?.operatorId,
    name: operator?.name,
  }));
  const val = [...list]?.sort((a, b) => a.name?.localeCompare(b?.name));
  return [{ id: '1', name: 'All Operator' }]?.concat(val);
});
export const getProductDetail = createSelector(
  [getProducts, getOperator, getLoactions],
  (product, operator, location) => {
    const operatorVal = (id: string) =>
      operator?.operators?.data?.find(
        (operator) => operator?.operatorId === id,
      );
    const locationVal = (id: string) =>
      location?.locations?.data?.find(
        (location) => location?.locationId === id,
      );
    const productVal = (product as any)?.data?.products?.map((product: any) => ({
      ...product,
      operatorName: operatorVal(product?.operatorId)?.name,
      locationName: locationVal(product?.locationId)?.name,
    }));
    return {
      ...product,
      product: {
        ...product?.product,
        datas: productVal,
      },
    };
  },
);
